module.exports = __webpack_public_path__ + "static/media/restore.4080fe2e.svg";